import { render } from "./AlarmTriggersEditor.vue?vue&type=template&id=10acdc27"
import script from "./AlarmTriggersEditor.vue?vue&type=script&lang=js"
export * from "./AlarmTriggersEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__